import { routeTree } from '@/constants/routeTree.gen.js'
import UncaughtError from '@/components/errors/uncaughtError.jsx'
import { Route as FavoritesRoute } from '@/routes/_authenticated.favorites.jsx'
import { Route as IndexRoute } from '@/routes/index.jsx'
import { Route as LivestreamRoute } from '@/routes/_authenticated.livestream.$id.jsx'
import { Route as MeetingRoute } from '@/routes/_authenticated.meeting.$id.jsx'
import { Route as OnramperRoute } from '@/routes/onramper.jsx'
import { Route as PostRoute } from '@/routes/post.$id.jsx'
import { Route as ReportsRoute } from '@/routes/_authenticated.reports.jsx'
import { Route as StoreRoute } from '@/routes/store.$handle.jsx'
import { RouteLoadingIndicator } from '@/components/ui/loadingIndicator.jsx'

export const ROUTER_CONFIG = {
  defaultErrorComponent: UncaughtError,
  defaultPendingComponent: RouteLoadingIndicator,
  defaultPreload: 'intent',
  defaultPreloadDelay: 50,
  defaultViewTransition: true,
  pathParamsAllowedCharacters: ['@'],
  routeTree,
}

export const ROUTES = Object.entries({
  favorites: FavoritesRoute,
  index: IndexRoute,
  livestream: LivestreamRoute,
  meeting: MeetingRoute,
  onramper: OnramperRoute,
  post: PostRoute,
  reports: ReportsRoute,
  store: StoreRoute,
})
